export const featuredBannerEvent = [
  {
    id_event: 10,
    name_event: 'MEGADETH - Historia del Metal',
    name_type_event: 'Musical',
    id_type_event: 1,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/banners2/csi012_lg_1_2_banner.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/banners2/csi012_lg_1_2_banner.jpg',
    location_event: 'Estadio de Anoeta',
    date_formmatted_event: '23 de abril 2026',
    time_formmatted_event: '20:00 PM',
    min_price_event_zone: '180.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 11,
    name_event: 'MEGADETH - Historia del Metal',
    name_type_event: 'Musical',
    id_type_event: 1,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/banners2/csi012_lg_1_2_banner.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/banners2/csi012_lg_1_2_banner.jpg',
    location_event: 'Estadio de Anoeta',
    date_formmatted_event: '23 de abril 2026',
    time_formmatted_event: '20:00 PM',
    min_price_event_zone: '180.00',
    name_money: 'S/',
    sold_out: 0,
  }
];

export const mockEvents = [
  {
    id_event: 1,
    name_event: 'The Killers en Lima',
    name_type_event: 'Musical',
    id_type_event: 1,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Estadio Nacional de Lima',
    date_formmatted_event: '23 de marzo 2026',
    time_formmatted_event: '19:00 PM',
    min_price_event_zone: '150.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 2,
    name_event: 'Shakira - Las Mujeres Ya No Lloran Tour',
    name_type_event: 'Musical',
    id_type_event: 1,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Estadio San Marcos',
    date_formmatted_event: '15 de noviembre 2025',
    time_formmatted_event: '19:30 PM',
    min_price_event_zone: '200.00',
    name_money: 'S/',
    sold_out: 1,
  },
  {
    id_event: 3,
    name_event: 'Peru vs Chile - Eliminatorias',
    name_type_event: 'Deportes',
    id_type_event: 2,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Estadio Nacional',
    date_formmatted_event: '09 de octubre 2025',
    time_formmatted_event: '20:30 PM',
    min_price_event_zone: '75.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 4,
    name_event: 'Macbeth - Shakespeare',
    name_type_event: 'Teatro',
    id_type_event: 3,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Teatro Municipal de Lima',
    date_formmatted_event: '18 de octubre 2025',
    time_formmatted_event: '19:00 PM',
    min_price_event_zone: '45.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 5,
    name_event: 'Oppenheimer - Premiere Exclusiva',
    name_type_event: 'Cine',
    id_type_event: 4,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Cineplanet Jockey Plaza',
    date_formmatted_event: '22 de octubre 2025',
    time_formmatted_event: '19:30 PM',
    min_price_event_zone: '0.00',
    name_money: 'Gratis',
    sold_out: 0,
  },
  {
    id_event: 6,
    name_event: 'Bad Bunny - Nadie Sabe Lo Que Va a Pasar',
    name_type_event: 'Musical',
    id_type_event: 1,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Jockey Club de Lima',
    date_formmatted_event: '12 de diciembre 2025',
    time_formmatted_event: '19:00 PM',
    min_price_event_zone: '250.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 7,
    name_event: 'Alianza Lima vs Universitario',
    name_type_event: 'Deportes',
    id_type_event: 2,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Estadio Alejandro Villanueva',
    date_formmatted_event: '05 de noviembre 2025',
    time_formmatted_event: '19:15 PM',
    min_price_event_zone: '50.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 8,
    name_event: 'La Casa de Bernarda Alba',
    name_type_event: 'Teatro',
    id_type_event: 3,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Teatro Británico',
    date_formmatted_event: '25 de octubre 2025',
    time_formmatted_event: '19:45 PM',
    min_price_event_zone: '60.00',
    name_money: 'S/',
    sold_out: 0,
  },
  {
    id_event: 9,
    name_event: 'Dune Part Two - IMAX',
    name_type_event: 'Cine',
    id_type_event: 4,
    banner_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    image_event: 'https://cdn.teleticket.com.pe/images/eventos/csi013_calugalistado.jpg',
    location_event: 'Cinépolis Real Plaza',
    date_formmatted_event: '28 de octubre 2025',
    time_formmatted_event: '20:00 PM',
    min_price_event_zone: '35.00',
    name_money: 'S/',
    sold_out: 0,
  },
];


// src/components/categoriesData.js
export const categories = [
  { id: "festivales", label: "FESTIVALES", icon: "fa-theater-masks" },
  { id: "conciertos", label: "CONCIERTOS", icon: "fa-music" },
  { id: "comida-bebida", label: "COMIDA Y BEBIDA", icon: "fa-utensils" },
  { id: "deportes", label: "DEPORTES", icon: "fa-futbol" },
  { id: "cultura", label: "CULTURA", icon: "fa-book-open" },
  { id: "conferencias", label: "CONFERENCIAS", icon: "fa-podcast" },
  { id: "standup", label: "STAND UP", icon: "fa-microphone" },
  { id: "talleres", label: "TALLERES Y CURSOS", icon: "fa-chalkboard-teacher" },
  { id: "yoga", label: "YOGA Y FITNESS", icon: "fa-spa" },
  { id: "competencias", label: "COMPETENCIAS", icon: "fa-flag-checkered" },
  { id: "otros", label: "OTROS", icon: "fa-paper-plane" },
];
